app.directive('customFile', function () {
    return {
        restrict: 'C',
        link: function ($scope, $element) {
            var $input = $element.find('input[type=file]');
            var $textContainer = $element.find('.custom-file-label');
            var noValueLabel = $textContainer.text();
            var baseNameRegex = /^.+[/\\]/;

            $input.on('change', function () {
                var path = $input.val();

                if (typeof path !== 'string' || path === '') {
                    $textContainer.text(noValueLabel);
                } else {
                    var basename = path.replace(baseNameRegex, '');
                    $textContainer.text(basename);
                }
            });
        }
    };
});